import { render, staticRenderFns } from "./old_LpProdOption.vue?vue&type=template&id=c313569c&scoped=true"
import script from "./old_LpProdOption.vue?vue&type=script&lang=js"
export * from "./old_LpProdOption.vue?vue&type=script&lang=js"
import style0 from "./old_LpProdOption.vue?vue&type=style&index=0&id=c313569c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c313569c",
  null
  
)

export default component.exports